
/**
 * 中转出发
 * @startDate
 * @endDate
 * @scanSite
 * @type
*/
export const TransitDeliveryQuery = (params) => {
  return [
    {
      // title: '中转发出-实际',
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      simpleGranularity: params.type || 'day',
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '否'},
        {key: 'scanSite', value: params.scanSite},
      ],
    }
  ]
}

/**
 * 网点出发
 * @startDate
 * @endDate
 * @scanSite
*/
export const SiteDepartQuery = (params) => {
  return {
    // title: '中转发出-实际',
    dataSource: 'actual_load_unload_result',
    dimensions: ['scanSite'],
    simpleGranularity: 'day',
    startDate: params.startDate,
    endDate: params.endDate,
    andFilters: [
      {key: 'scanType', value: '分拨装车'},
      {key: 'isDestinationCenter', value: '是'},
      {key: 'scanSite', value: params.scanSite},
    ],
  }
}

/**
 * 已发车分拨查询
 * @scanSite
 * @siteName 
 * @startDate
 * @endDate
 * @nextProvinceArea
*/
export const DepartureQuery = (params) => {
  return [
    {
      // 查下一站 14天货量
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      simpleGranularity: 'day',
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'siteName', value: params.siteName},
        {key: 'scanSite', value: params.scanSite},
        {key: 'scanType', value: '分拨装车'},
      ]
    },
    {
      // 查下一站省区
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      simpleGranularity: 'day',
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'nextProvinceArea', value: params.nextProvinceArea},
        {key: 'scanSite', value: params.scanSite},
        {key: 'scanType', value: '分拨装车'},
      ]
    },
  ]
}

/**
 * 线路查发出量
 * @startDate
 * @endDate
 * @trackLine
 * @scanSite
*/
export const TrackLineQuery = (params) => {
  return {
    dataSource: 'actual_load_unload_result',
    dimensions: [],
    simpleGranularity: 'day',
    startDate: params.startDate,
    endDate: params.endDate,
    andFilters: [
      {key: 'scanType', value: '分拨装车'},
      {key: 'trackLine', value: params.trackLine},
      {key: 'scanSite', value: params.scanSite},
    ]
  }
}

/**
 * 线路查产品类型 
*/
const productItem = ['MINI电商小件', '精准零担', 'MINI电商大件', '定时达', '安心达', '普惠达'];
export const TrackLineTypeQuery = (trackLine, scanSite) => {
  const items = [];
  productItem.forEach(item => {
    items.push({
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      andFilters: [
        {key: 'productType', value: item},
        {key: 'scanType', value: '分拨装车'},
        {key: 'trackLine', value: trackLine},
        {key: 'scanSite', value: scanSite},
      ]
    })
  })
  return items;
}